<div class="container">
  <div class="row">
    <div class="col">
      <div class="beta-cells__container d-flex">
        <div class="beta-cells__text">
          <h2 class="title text-uppercase text-gray-900">
            What are <span class="text-primary fst-italic">beta cells?</span>
          </h2>
          <h2 class="mb-3">They’re small but central to T1D</h2>
          <div class="beta-cells__image mt-lg-4 d-lg-none mb-4">
            <picture
              [data]="{
                image: 'what-is-t1d/beta-images',
                webp: true,
                altext: betaCellsImageAlt,
                format: '',
                width: '414',
                height: '371',
                mobile: false,
                classes: 'img-fluid',
              }"
            ></picture>
          </div>
          <p class="mb-3">
            Beta cells make insulin—and people need insulin to convert blood
            sugar into energy and help the body stay healthy. In T1D, part of
            your immune system begins mistakenly attacking these beta cells.
            When too many beta cells have been destroyed, your body is unable to
            make enough insulin to keep your blood sugar level within a healthy
            range. This can cause serious health complications over time.
          </p>
          <p>
            By Stage 3 T1D, a significant number of beta cells have been damaged
            and the body can no longer make enough insulin on its own. At this
            point symptoms appear and daily insulin therapy becomes necessary.
            But even a small number of beta cells may help the body continue
            making some insulin, supporting steadier blood sugar levels with
            fewer highs and lows.
          </p>
          <p class="fw-semibold mb-4 mb-lg-5">
            Watch the video to learn more about beta cells and why early
            screening matters.
          </p>
        </div>
        <div class="beta-cells__image mt-lg-4 d-none d-lg-block">
          <picture
            [data]="{
              image: 'what-is-t1d/beta-images',
              webp: true,
              altext: betaCellsImageAlt,
              format: '',
              width: '414',
              height: '371',
              mobile: false,
              classes: 'img-fluid',
            }"
          ></picture>
        </div>
      </div>
      <div
        video-carousel
        [videoCarouselData]="videoData"
        [transcript]="true"
      ></div>
    </div>
  </div>
</div>
